/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.


import classnames from 'classnames'
import PropTypes from 'prop-types'
import { HotKeys } from 'react-hotkeys'
import moment from 'moment'

import { captureExceptions } from 'utils/SentryHelpers'
import SearchResultTypesEnum from 'constants/SearchResultTypesEnum'
import MomentCalendarPresets from 'constants/MomentCalendarPresets'

import Avatar from 'shared-web/src/components/Avatar'
import Input from 'shared-web/src/components/Input'
import Modal from 'components/Modal'
import ResultPreview from './ResultPreview'

import './style'

const TIME_DELAY = 250
let TIMEOUT = null

const GLOBAL_SEARCH_KEY = 'globalSearch'

const openGlobalSearch = function({ location, router }) {
  const globalSearch = {}
  globalSearch[GLOBAL_SEARCH_KEY] = ''
  const query = _.assign(location.query, globalSearch)
  const { pathname } = location
  return router.push({ pathname, query })
}

const GlobalSearch = React.createClass({
  displayName: 'GlobalSearch',

  contextTypes: {
    router: PropTypes.object.isRequired,
    location: PropTypes.object
  },

  propTypes: {
    onClose: PropTypes.func.isRequired
  },

  getInitialState() {
    return {
      query: this.getSearchQuery(),
      selectedResult: {},
      selectedIndex: undefined
    }
  },

  getSearchQuery() {
    let query = this.props.query != null ? this.props.query.globalSearch : undefined
    if (query === '/') {
      query = ''
    }
    return query || ''
  },

  componentDidMount() {
    this.app.stores.ConversationStore.resetSearchResults()
    this.app.stores.EndUserStore.resetSearchResults()

    if (this.getSearchQuery()) {
      return this.handleInputChange(this.getSearchQuery())
    }
  },

  handleInputChange(newQuery) {
    if (newQuery === '/') { return }

    if (!_.isEmpty(newQuery.trim())) {
      clearTimeout(TIMEOUT)

      TIMEOUT = _.delay(() => {
        this.app.actions.ConversationActions.searchConversations(newQuery)
        return this.app.actions.EndUserActions.searchEndUser(this.props.currentOrg.id, newQuery)
      }
      , TIME_DELAY)
    }

    const { query } = this.props
    query.globalSearch = newQuery

    this.context.router.push({ pathname: this.context.location.pathname, query })

    return this.unselectResult()
  },

  unselectResult() {
    return this.setState({
      selectedResult: {},
      selectedIndex: undefined
    })
  },

  flattenResultItems(collection) {
    const results = collection || []
    return _.map(results, function(item) {
      const newResult = item._source
      newResult.type = item._type
      return newResult
    })
  },

  getConversationItems() {
    return this.flattenResultItems(this.props.conversationSearchResults[this.getSearchQuery()])
  },

  getUserItems() {
    return this.flattenResultItems(this.props.endUserSearchResults[this.getSearchQuery()])
  },

  // If we merge all of the item types into a single list, it's easier to hot key move over them
  // Make sure to put them in the order in which they appear
  getCombinedItems() {
    return this.getUserItems().concat(this.getConversationItems())
  },

  renderUserItem(user, i) {
    const key = `result-item-${i}`
    return (
      <div
        key={key}
        className={classnames('result-item', { isSelected: this.isItemSelected(SearchResultTypesEnum.endUser.key, user) })}
        onMouseOver={this.hoverOverItem.bind(this, SearchResultTypesEnum.endUser.key, user, i)}
        onClick={this.selectResult}
        ref={ref => this[key] = ref}>
        <div className="main-data">
          <Avatar user={user} />
          <div className="intro-text">
            {user.name || user.email}
          </div>
        </div>
        <div className="extra-data">
          <div className="details-text">
            {user.attributes.lastActive ?
              `Last active on ${moment(user.attributes.lastActive).calendar(null, MomentCalendarPresets.detailedSameDay)}` : undefined}
          </div>
        </div>
      </div>
    )
  },

  hoverOverItem(type, item, i) {
    return this.setState({
      selectedResult: item,
      selectedIndex: i
    })
  },

  isItemSelected(type, item) {
    return ((this.state.selectedResult != null ? this.state.selectedResult.type : undefined) === type) && ((this.state.selectedResult != null ? this.state.selectedResult.id : undefined) === item.id)
  },

  renderConversationItem(conversation, i) {
    const key = `result-item-${i}`
    return (
      <div
        key={key}
        className={classnames('result-item', { isSelected: this.isItemSelected(SearchResultTypesEnum.conversation.key, conversation) })}
        onMouseOver={this.hoverOverItem.bind(this, SearchResultTypesEnum.conversation.key, conversation, i)}
        onClick={this.selectResult}
        ref={ref => this[key] = ref}>
        <div className="content">
          <div className="title">
            {`#${ conversation.displayId } ${ conversation.subject || '' }`}
          </div>
          <div className="metadata">
            <span>
              {`${ (this.props.endUsersById[conversation.endUserId] != null ? this.props.endUsersById[conversation.endUserId].name : undefined) || (this.props.endUsersById[conversation.endUserId] != null ? this.props.endUsersById[conversation.endUserId].email : undefined) } | `}
            </span>
            <span>
              {`${ moment(conversation.updatedAt).calendar(null, MomentCalendarPresets.detailedSameDay) } | `}
            </span>
            <span>
              {`${ (this.props.inboxesById[conversation.inboxId] != null ? this.props.inboxesById[conversation.inboxId].name : undefined) } | `}
            </span>
            <span className={classnames('status', conversation.status)}>
              {conversation.status}
            </span>
          </div>
        </div>
      </div>
    )
  },

  renderCategory(title, collection, renderMethod, indexOffset) {
    if (_.isEmpty(collection)) { return }

    return (
      <div>
        <div className="result-category">
          <div className="result-category-header">
            <span>
              {title}
            </span>
          </div>
        </div>
        {_.map(collection, (item, index) => renderMethod(item, index + indexOffset))}
      </div>
    )
  },

  renderCategoryResults() {
    const usersIndexOffset = 0
    const conversationsIndexOffset = usersIndexOffset + this.getUserItems().length

    return (
      <div>
        {this.renderCategory('Customers', this.getUserItems(), this.renderUserItem, usersIndexOffset)}
        {this.renderCategory('Conversations', this.getConversationItems(), this.renderConversationItem, conversationsIndexOffset)}
      </div>
    )
  },

  renderResults() {
    return (
      <div className="results-container">
        <div
          className={classnames('results', {
            'preview-visible': (this.state.selectedResult != null ? this.state.selectedResult.id : undefined)
          })}>
          {this.renderCategoryResults()}
        </div>
        {(this.state.selectedResult != null ? this.state.selectedResult.id : undefined) ?
          <div className="preview">
            <ResultPreview item={this.state.selectedResult} />
          </div> : undefined}
      </div>
    )
  },

  changeSelectedIndex(direction) {
    let newIndex
    const currentResult = this.state.selectedResult
    const currentIndex = this.state.selectedIndex
    const allItems = this.getCombinedItems()

    if ((direction > 0) && (currentIndex === (allItems.length - 1))) { return }
    if ((direction < 0) && ((currentIndex === 0) || (currentIndex === undefined))) { return this.unselectResult() }

    if (currentIndex === undefined) {
      newIndex = 0
    } else {
      newIndex = currentIndex + direction
    }

    const newItem = allItems[newIndex]

    this.setState({
      selectedResult: newItem,
      selectedIndex: newIndex
    })

    const element = this[`result-item-${newIndex}`]
    return (element != null ? element.scrollIntoViewIfNeeded(false) : undefined)
  },

  selectResult() {
    const { selectedResult } = this.state

    if (selectedResult.id !== undefined) {
      this.props.onClose()
      switch (selectedResult.type) {
        case SearchResultTypesEnum.conversation.key: return this.goToConversation(selectedResult.inboxId, selectedResult.id)
        case SearchResultTypesEnum.endUser.key: return this.goToUser(selectedResult.id)
      }
    }
  },

  goToConversation(inboxId, conversationId) {
    const path = `/inboxes/${ inboxId }/conversations/${ conversationId }`
    return this.context.router.push(path)
  },

  goToUser(userId) {
    const path = `/contacts/details/${ userId }`
    window.location.pathname = path
  },

  render() {
    const combinedResults = this.getCombinedItems()

    return (
      <Modal onClose={this.props.onClose} modalContentClassName="GlobalSearch">
        <HotKeys
          keyMap={{
            moveDown: 'down',
            moveUp: 'up',
            selectResult: ['enter', 'return']
          }}
          handlers={{
            moveDown: () => this.changeSelectedIndex(1),
            moveUp: () => this.changeSelectedIndex(-1),
            selectResult: this.selectResult
          }}>
          <div
            className={classnames('search-container', { 'no-results': combinedResults.length !== 0 })}>
            <Input
              autoFocus={true}
              placeholder="Search"
              valueLink={{
                value: this.getSearchQuery(),
                requestChange: this.handleInputChange
              }}
              isValid={true} />
            <img
              className="search-icon"
              src={require('images/icons/magnifying-glass-icon.svg')} />
            <div className="num-results">
              {`${ combinedResults.length } Results`}
            </div>
          </div>
          {!_.isEmpty(this.getSearchQuery()) && (combinedResults.length !== 0) ? this.renderResults() : undefined}
        </HotKeys>
      </Modal>
    )
  }
})

const GlobalSearch$1 = Marty.createContainer(GlobalSearch, {
  listenTo: ['stores.EndUserStore', 'stores.ConversationStore', 'stores.InboxStore'],

  fetch: {
    endUserSearchResults() {
      return this.app.stores.EndUserStore.getSearchResults()
    },

    conversationSearchResults() {
      return this.app.stores.ConversationStore.getSearchResults()
    },

    currentOrg() {
      return this.app.stores.OrgStore.getOrFetchCurrentOrg()
    },

    endUsersById() {
      return this.app.stores.EndUserStore.getEndUsersById()
    },

    inboxesById() {
      return this.app.stores.InboxStore.getOrFetchInboxList()
    }
  },

  failed(errors) {
    captureExceptions(errors)
    return <div />
  }
})

export { GlobalSearch$1 as GlobalSearch }
export { openGlobalSearch }

export { GLOBAL_SEARCH_KEY }



// WEBPACK FOOTER //
// ./src/scripts/components/GlobalSearch/index.js